import type { SimpleChanges } from '@angular/core';
import { ChangeDetectionStrategy, Component, output, input } from '@angular/core';

import moment from 'moment-timezone';

import { TranslatePipe } from '@core/i18n-legacy';
import { DatePickerComponent, DatePickerDirection } from '@core/time-ui';
import type { ConnectedOverlayDirective } from '@core/user-interface-legacy';
import { IconComponent, ButtonComponent, DropdownComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-schedule-date-dropdown',
  templateUrl: 'schedule-date-dropdown.component.html',
  styleUrls: ['./schedule-date-dropdown.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DropdownComponent, DatePickerComponent, ButtonComponent, IconComponent, TranslatePipe],
})
export class ScheduleDateDropdownComponent {
  public readonly direction = input<DatePickerDirection>('today-future');
  public readonly currentDate = input<string>(undefined!);
  public readonly dropdownRef = input<ConnectedOverlayDirective>(undefined!);
  public readonly closeOnDateChange = input<boolean>(false);
  public readonly showClear = input<boolean | undefined>(false);
  public readonly useYearNav = input<boolean>(false);
  public readonly blackoutDates = input<((date: moment.Moment) => boolean) | null>(null);

  public dateChange = output<moment.Moment | undefined>();

  public date: string;

  public ngOnChanges(changes: SimpleChanges): void {
    const currentDate = changes.currentDate && changes.currentDate.currentValue;

    if (currentDate) {
      this.date = moment(currentDate, 'DD MMM YYYY').format('YYYY-MM-DD');
    }
  }

  public onDateChange(date: string): void {
    this.dateChange.emit(date?.length ? moment(date, 'YYYY-MM-DD') : undefined);
    if (this.closeOnDateChange()) {
      this.dropdownRef().open = false;
    }
  }
}
